import BarChart from '../../charts/barChart'
import ApiService from '../../../../../../services/ApiService'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { GaugeChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  GaugeChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  props: {
    filterProp: Object,
  },
  components: {
    BarChart,
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  data() {
    return {
      chartWidth: 900,
      chartKey: false,
      apiService: new ApiService(),
      loading: false,
      internalResolvability: undefined,
      page: 1,
      exampleValue: 50,
      totalPages: 1,
      pageSize: 7,
      val: 5,
      percent: 0,
      options: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: true,
            color: '#fff',
            anchor: 'center',
            align: 'center',
            font: {
              weight: 'bold',
            },
            formatter: (value) => {
              return value > 0 ? value : ''
            },
          },
        },
      },
      optionsGauge: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        series: [
          {
            type: 'gauge',
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.3, '#ED8990'],
                  [0.7, '#FDB578'],
                  [1, '#BCD504'],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: 'auto',
              },
            },
            axisTick: {
              distance: -20,
              length: 5,
              lineStyle: {
                color: '#fff',
                width: 1,
              },
            },
            splitLine: {
              distance: -20,
              length: 20,
              lineStyle: {
                color: '#fff',
                width: 3,
              },
            },
            axisLabel: {
              color: 'auto',
              distance: 15,
              fontSize: 10,
            },
            detail: {
              valueAnimation: true,
              formatter: '{value} %',
              color: 'auto',
              fontSize: 10,
            },
            data: [
              {
                value: 0,
              },
            ],
          },
        ],
      },
      internalResolvabilityChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      internas: [],
      internasMaisExternas: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },

  async created() {
    this.listInternalResolvability()
  },

  computed: {
    haveData() {
      return this.data.dataByMonth.length > 0
    },
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `internal_Resolvability_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/internalResolvability', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listInternalResolvability() {
      await this.apiService
        .post('reports/internalResoluteness', this.filterProp)
        .then((response) => {
          this.data = response.content
          this.internalResolvability = [this.data]
        })
        .catch((err) => {})

      this.fillInternalResolvabilityChartData()
    },
    fillInternalResolvabilityChartData() {
      const labels = this.data.dataByMonth.map((x) => x.month);
      const labelsCount = labels.length;
      const widthPerMonth = 70;
      this.chartWidth = Math.max(labelsCount * widthPerMonth, 900);
      this.internalResolvabilityChartData = {
        labels,
        datasets: [
          {
            label: this.$t('Porcentagem'),
            data: this.data.dataByMonth.map(x => x.percentage),
            backgroundColor: '#0288d1',
          },
        ],
      };
      setTimeout(() => {
        this.chartKey = !this.chartKey;
      }, 100);
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listInternalResolvability()
    },
    percent(nv, ov) {
      this.optionsGauge.series[0].data[0].value = nv
    },
  },
}
